import {
  Calendar, PieChart, Briefcase, Users, Watch, 
  Activity
} from 'react-feather'

const dailyEvaluationBadgeText = localStorage.getItem('peddingDailyEvaluation') || '';
const dailyEvaluationBadgeColor = dailyEvaluationBadgeText > 0 ? 'danger' : '';
const dailyEvaluationMenuDisable = dailyEvaluationBadgeText > 0 ?  false : true;

console.log(!dailyEvaluationMenuDisable)

export default [
  {
    id: "dashboard",
    title: "Dashboard",
    icon: <PieChart size={20} />,
    navLink: "/dashboard/analytics",
  },
  {
    id: "patient",
    title: "Paciente",
    icon: <Users />,
    navLink: "/patients",
  },
  {
    id: "health_insurances",
    title: "Convênio",
    icon: <Briefcase size={20} />,
    navLink: "/health-insurances",
  },
  {
    id: "schedule",
    title: "Agenda",
    icon: <Calendar size={20} />,
    navLink: "/apps/calendar",
  },
  {
    id: "waiting_room",
    title: "Sala de Espera",
    icon: <Watch size={20} />,
    navLink: "/waiting-room",
  },
  {
    id: "daily_evaluation",
    title: "Evolução Diária",
    icon: <Activity size={20} />,
    navLink: "/daily-evaluation",
    badge: dailyEvaluationBadgeColor,
    badgeText: dailyEvaluationBadgeText,
    disabled: dailyEvaluationMenuDisable
  },
  // {
  //   id: "user",
  //   title: "Usuários",
  //   icon: <Users size={20} />,
  //   navLink: "/users",
  // },
];

